// 
// import filtersJSON from './filters.json';

export default function menuFilters() {
  const filtersModal = document.querySelector('#filters-modal');
  if (!filtersModal) return;

  const filtersModalBody = filtersModal.querySelector('.modal-body');
  const filtersWrapper = document.querySelector('.menu-page-filters');
  const filterButtons = filtersWrapper.querySelectorAll('[type="checkbox"]');
  const filtersSelectedCount = filtersWrapper.querySelector('#filters-selected-count');

  const productGrid = document.querySelector(".menu-page-products-grid");


  if (!productGrid || !filtersWrapper || !filterButtons) return;

  let allFilters = [];

  function closeModal() {
    window.SD_CloseModal(filtersModal); // there is also window.SD_OpenModal
  }

  function showLoader() {
    filtersModalBody.classList.add('loading')
  }
  function hideLoader() {
    filtersModalBody.classList.remove('loading')
  }

  function getQueryString() {
    const formData = new FormData(document.getElementById('product-filters'));
    return new URLSearchParams(formData).toString();
  }

  function makeQuery(queryString) {
    const siteUrl = window.SD_SITE_URL ?? 'https://wa-prod-sushidaily-hkeqaebfdwftggam.uksouth-01.azurewebsites.net/';
    return fetch(`${siteUrl}umbraco/api/productsapi/filter?${queryString}`, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
    })
      .then((res) => {
        return res.json()
      })
  }


  function hideShowProducts(products) {
    if (!products) return;

    products.forEach(function ({ Id, Visible }) {
      const product = productGrid.querySelector(`[data-id='${Id}']`);

      if (!product) return;
      
      product.classList.toggle('hidden', !Visible)
    })
  }

  // click show filter buttons
  // show filters
  // click filter adds to array
  // apply makes the query
  filtersWrapper.addEventListener("click", (e) => {
    const element = e.target;
    const { name, value, type } = element;
    const isCheckbox = type === 'checkbox'
    const isClearButton = name === 'clear'
    const isApplyButton = name === 'apply'

    if (!isCheckbox && !isClearButton && !isApplyButton) return;

    if (isApplyButton) {
      closeModal()
      return;
    }

    if (isClearButton) {
      // build up query params
      const checked = filtersWrapper.querySelectorAll('[type="checkbox"]:checked');
      if (checked) {
        [...checked].forEach((checkbox) => {
          checkbox.checked = false;
        })
      }
      filtersSelectedCount.innerHTML = 0;
      allFilters = [];
      closeModal();
    }

    // show loader
    showLoader()

    // make query
    makeQuery(getQueryString()).then((resData) => {
      if (resData === null) {
        console.error('data is null')
        return
      }

      const { collections, types, allergens, results } = resData;
      const filters = { collections, types, allergens }

      // select or deselect and disabled filter button checkboxes
      for (let key in filters) {
        filters[key].forEach(function (filter) {
          const checkbox = filtersWrapper.querySelector(`[value="${filter.id}"`)
          if (!checkbox) return;

          const checkboxParent = checkbox.parentNode;
          const isDisabled = filter.results === 0

          if (key !== 'allergens') {
            if (isDisabled) checkboxParent.classList.add('disabled');
            if (!isDisabled) checkboxParent.classList.remove('disabled');
          }

          if (checkbox.checked) checkboxParent.classList.add('selected');
          if (!checkbox.checked) checkboxParent.classList.remove('selected');
        })
      }

      if (isCheckbox) {
        if (element.checked) {
          allFilters.push({ name, value })
        } else {
          allFilters = allFilters.filter((filter) => filter.value !== value)
        }
      }

      // update filter count
      filtersSelectedCount.innerHTML = allFilters.length

      hideShowProducts(results);
      hideLoader()
    }).catch((err) => {
      hideLoader()
      // undo check if fails
      element.checked = false;
      console.error(err)
    });

  });
}